const API_HOST = process.env.REACT_APP_API_URL;
const API_BASE = '/api';
const VERSION_V1 = '/v1';
export const SMART_LOCK_API_ENDPOINTS = {
  ROUTE_URL: '/api/v1/routes',
  TRIP_URL: '/api/v1/trips',
  TRIP_START: '/api/v1/trips/updateTripStartStatus',
  UPDATE_DRIVER_DETAILS: '/api/v1/trips/updateDriverDetails',
  TRIP_DATA_EVENTS: '/api/v1/trips/getTripEvents',
  TRIP_DATA: '/api/v1/trips/getTripData',
  END_TRIP: '/api/v1/trips/updateTripEndStatus',
  TRACKING_TRIP_LOCATION: '/api/v1/trips/getTrackData',
  VEHICLE_URL: '/api/v1/vehicles',
  DEVICE_URL: '/api/v1/devices',
  ALL_DEVICE_DATA: '/api/v1/devices/getdevice/list',
  DEVICE_ODOMETER: '/api/v1/devices/reports/getTotalDistance',
  DEVICE_EVENT: '/api/v1/devices/reports/getDeviceEvents',
  DEVICE_INVENTORY: '/api/v1/deviceInventory',
  ALL_ROUTE_DATA: '/api/v1/routes/getroutes/list',
  ALL_VEHICLE_DATA: '/api/v1/vehicles/getvehicles/list',
  ALL_ORGANIZATION_DATA: '/api/v1/organizations/getOrganization/list',
  ALL_ROLE_DATA: '/api/v1/userRole/getUserRole/list',
  TRIP_DATA_BY_DEVICE_ID: '/api/v1/trips/getTripListByDeviceId',
  BULK_CREATE_DEVICE: '/api/v1/devices/bulkcreate',
  UPDATE_ORGANIZATION: '/api/v1/deviceInventory/changeOrganizations',
  UPDATE_RFID_CARD: '/api/v1/devices/updateRfidCard',
  RESET_PASSWORD: '/api/v1/auth/reset/password',
  GENERATE_OTP: '/api/v1/auth/forgot/password',
  SIGN_IN: '/api/v1/auth/admin/email/login',
  COGNITO_SESSION_TOKEN: '/api/v1/cognito/authenticate',
  ADMIN_SIGN_OUT: '/auth/logout',
  ORGANIZATION_URL: '/api/v1/organizations',
  ORGANIZATION_STATUS_UPDATE: '/api/v1/organizations/StatusUpdate',
  ORGANIZATION_DEFAULT_SETTING: '/api/v1/organizations/setting/defaultValue',
  ASSIGN_DEVICE_ORG: '/api/v1/deviceInventory/assignOrganizations',
  ASSIGN_DEVICE_DEPARTMENT:'/api/v1/devices/assign-to-department',
  USER_URL: '/api/v1/users',
  GET_DEVICE_STATS: '/api/v1/main-page-stats/devices',
  GET_VEHICLE_STATS: '/api/v1/main-page-stats/vehicles',
  GET_TRIP_STATS: '/api/v1/main-page-stats/trips',
  GET_DASHBOARD_DATA: '/api/v1/main-page-stats/getdashboardData',
  TICKET_MANAGEMENT_URL: '/api/v1/help-center',
  ROLE_URL: '/api/v1/userRole',
  GET_RFID_CARD: '/api/v1/devices/getRfidCards',
  DEVICE_ACTION: '/api/v1/payload',
  EXPORT_DEVICE_REPORT: '/api/v1/devices/reports/exportHistoryData',
  RFID_DETAIL: '/api/v1/devices/getRfidCardsDetails',
  OPEN_LOCK_COMMAND: '/api/v1/payload/lockOpen',
  UPDATENOTIFICATIONRESOLVED: '/api/v1/main-page-stats/updateNotificationAsResolved',
  GET_FOTA_LOGS: '/api/v1/fota/logs',
  SAVE_FOTA_VERSION: '/api/v1/fota/versions',
  APPLY_FOTA_VERSION: '/api/v1/fota/apply',
  GET_ALL_NOTIFICATIONS: '/api/v1/notifications',
  SEND_EVENT_TO_DEVICE: '/action-event-sent-to-devices',
  GET_LOCK_ACTIONS: '/lock-actions',
  TRIP_HISTORY_DATA: '/api/v1/trips/getTripNotifications',
  ADD_VIP_NUMBER: '/api/v1/payload/addVipMobileNumber',
  ADD_ADMIN_NUMBER: '/api/v1/payload/adminMobileNumberChange',
  UPDATE_VIP_NUMBER: '/api/v1/payload/updateVipMobileNumber',
  ASSIGN_VEHICLE: '/api/v1/devices/assignVehicle',
  DEVICE_LOCATION: '/api/v1/devices/reports/getLocationHistoryData',
  GET_USER_ACTIVITY: '/api/v1/usersActivity',
  UPDATE_GEOFENCE: '/api/v1/trips/updateGeoFence',
  DEVICE_ID_LIST: '/api/v1/help-center/getdevice/list',
  BULK_ASSIGN_DEVICE_TO_ORGANIZATION: '/api/v1/deviceInventory/bulkAssignOrganizations',
  GET_LOCATION_BY_LAT_LNG: '/api/v1/location',
  DEPARTMENT_LIST: '/api/v1/departments',
  DOWNLOAD_FORMAT: '/api/bulkDeviceAssigntemplate'
};

export const IOT_NOTIFICATION_EVENTS = {
  FLAMMABLE_GAS_DETECTED_ALERT: 'FLAMMABLE_GAS_DETECTED_ALERT',
  FLAMMABLE_GAS_SENSOR_ERROR: 'FLAMMABLE_GAS_SENSOR_ERROR',
  DEVICE_FALL_ALERT: 'DEVICE_FALL_ALERT',
  DEVICE_PROXIMITY_ALERT: 'DEVICE_PROXIMITY_ALERT',
  DEVICE_SCANNER_DATA: 'SCANNER_DATA',
  DEVICE_BATTERY_LOW_ALERT: 'DEVICE_BATTERY_LOW_ALERT'
};

export const APP_CONSTANTS = {
  L_KEY_OF_USER_DATA: 'puad',
  L_KEY_OF_USER_IOT_CLIENT_ID: 'padiotc',
  L_KEY_OF_USER_LOGGEDIN_STATUS: 'isLoggedin',
  L_KEY_OF_USER_ADMIN_SSOTOKEN: 'sso-token',
  L_KEY_OF_USER_ADMIN_COGNIO_CRED: 'cgntCred',
  G_MAP_API_KEY: 'AIzaSyAnWB533E-FJrEgeCWUQ7amty8z_5ytuB4',
  AWS_COGNITO_DATA: 'aws-cognito'
};

export const ONGOING_VIDEO_CALL_DATA = {
  id: 'no_data',
  userData: []
};

export const URL_CONSTANT = {
  DASHBOARD: '/dashboard',
  SMARTLOCK: '/dashboard/smartlock',
  TRIP: '/dashboard/trips',
  TRIP_DETAIL: '/dashboard/tripdetails',
  DEVICE: '/dashboard/devices',
  DEVICE_REPORT: '/dashboard/deviceReport',
  VEHICLE: '/dashboard/vehicle',
  ROUTES: '/dashboard/routes',
  USERMANAGEMENT: '/dashboard/userManagement',
  FOTALOGSMANAGEMENT: '/dashboard/fotalogsManagement',
  ACTIVITYLOG: '/dashboard/activitylogs',
  CONTROLCENTER: '/dashboard/smartlockControlCenter',
  TICKETMANAGEMENT: '/dashboard/ticketManagement',
  FORGOT_PASSWORD: '/forgot_password'
};
